/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var lory = __webpack_require__(1).lory;
window.initCarousel = function (carouselId, itemsPerSlide, makeGlobal) {
    if (makeGlobal === void 0) { makeGlobal = false; }
    var carouselItem = document.getElementById(carouselId);
    var infiniteBuffer = itemsPerSlide;
    if (carouselItem) {
        var loryOptions = {
            enableMouseEvents: true,
            infinite: itemsPerSlide,
            slideSpeed: 800,
            // linear transition 
            ease: 'cubic-bezier(0, 0, 1, 1)'
        };
        var dot_count_1 = carouselItem.querySelectorAll('.js_slide').length;
        var dot_container_1 = carouselItem.querySelector('.js_dots');
        var dot_list_item_1 = document.createElement('li');
        var nextBtn_1 = carouselItem.querySelector('.js_next');
        var prevBtn_1 = carouselItem.querySelector('.js_prev');
        dot_list_item_1.tabIndex = 0;
        function handleDotEvent(e) {
            if (e.type === 'before.lory.init') {
                for (var i = 0, len = dot_count_1; i < len; i++) {
                    var clone = dot_list_item_1.cloneNode();
                    clone.innerHTML = "<span class=\"visually-hidden\">Select slide " + (i + 1);
                    dot_container_1.appendChild(clone);
                }
                dot_container_1.children[0].classList.add('active');
            }
            if (e.type === 'after.lory.init') {
                for (var i = 0, len = dot_count_1; i < len; i++) {
                    dot_container_1.children[i].addEventListener('click', function (evt) {
                        if (makeGlobal) {
                            window[carouselId].slideTo(Array.prototype.indexOf.call(dot_container_1.children, evt.target));
                        }
                        else {
                            carouselContainer_1.slideTo(Array.prototype.indexOf.call(dot_container_1.children, evt.target));
                        }
                    });
                    dot_container_1.children[i].addEventListener('keyup', function (evt) {
                        if (evt.which == 13) {
                            if (makeGlobal) {
                                window[carouselId].slideTo(Array.prototype.indexOf.call(dot_container_1.children, evt.target));
                            }
                            else {
                                carouselContainer_1.slideTo(Array.prototype.indexOf.call(dot_container_1.children, evt.target));
                            }
                        }
                    });
                }
                nextBtn_1.addEventListener('keyup', function (evt) {
                    if (evt.which == 13) {
                        if (makeGlobal) {
                            window[carouselId].next();
                        }
                        else {
                            carouselContainer_1.next();
                        }
                    }
                });
                prevBtn_1.addEventListener('keyup', function (evt) {
                    if (evt.which == 13) {
                        if (makeGlobal) {
                            window[carouselId].prev();
                        }
                        else {
                            carouselContainer_1.prev();
                        }
                    }
                });
            }
            if (e.type === 'after.lory.slide') {
                for (var i = 0, len = dot_container_1.children.length; i < len; i++) {
                    dot_container_1.children[i].classList.remove('active');
                }
                dot_container_1.children[(e.detail.currentSlide - infiniteBuffer + dot_count_1) % dot_count_1].classList.add('active'); //complex to reference because of the "infinite" thing
            }
            if (e.type === 'on.lory.resize') {
                for (var i = 0, len = dot_container_1.children.length; i < len; i++) {
                    dot_container_1.children[i].classList.remove('active');
                }
                dot_container_1.children[0].classList.add('active');
            }
        }
        carouselItem.addEventListener('before.lory.init', handleDotEvent);
        carouselItem.addEventListener('after.lory.init', handleDotEvent);
        carouselItem.addEventListener('after.lory.slide', handleDotEvent);
        carouselItem.addEventListener('on.lory.resize', handleDotEvent);
        var carouselContainer_1 = null;
        if (makeGlobal) {
            window[carouselId] = lory(carouselItem, loryOptions);
        }
        else {
            carouselContainer_1 = lory(carouselItem, loryOptions);
        }
        /* Automatic transition
           Dev Notes: The transition speed is the property available only for the home page carousel.
           This property is used as a condition to automate the carousel rotation.
        */
        var transitionSpeed = carouselItem.getAttribute("data-transition-speed");
        if (transitionSpeed != null) {
            var notDesktop = window.innerWidth <= 768;
            if (notDesktop) {
                window.cancelAnimationFrame(reqAnimation);
            }
            else {
                var autoSlide, interval, startTime, currentTime, elapsed, reqAnimation;
                var playPause = document.getElementById("carouselPlayPauseJS");
                var playPauseSvg = playPause.querySelector("svg use");
                var sliderButton = document.querySelector(".carousel-buttons-inner-js");
                startAnimating(transitionSpeed);
                function startAnimating(speed) {
                    interval = (speed * 1000);
                    autoSlide = true;
                    sliderButton.addEventListener('click', function (e) {
                        autoSlide = false;
                        startTime = Date.now();
                        nextSlide();
                    });
                    if (autoSlide) {
                        startTime = Date.now();
                        animate();
                    }
                }
                function animate() {
                    reqAnimation = requestAnimationFrame(animate);
                    nextSlide();
                }
                function nextSlide() {
                    currentTime = Date.now();
                    elapsed = currentTime - startTime;
                    if (elapsed > interval) {
                        startTime = currentTime - (elapsed % interval);
                        if (makeGlobal) {
                            window[carouselId].next();
                        }
                        else {
                            carouselContainer_1.next();
                        }
                    }
                }
                playPause.addEventListener('click', function (e) {
                    var xlinkHref = 'xlink:href';
                    var svg = playPauseSvg.getAttribute(xlinkHref);
                    var playPauseElement = document.getElementById("playPauseTextJS");
                    var playPauseText;
                    if (svg.indexOf('play') != -1) {
                        startAnimating(transitionSpeed);
                        playPauseSvg.setAttribute(xlinkHref, "#icon-pause");
                        playPauseText = "Stop automatic transition";
                        playPause.setAttribute('data-is-paused', 'false');
                    }
                    else {
                        window.cancelAnimationFrame(reqAnimation);
                        playPauseSvg.setAttribute(xlinkHref, "#icon-play");
                        playPauseText = "Start automatic transition";
                        playPause.setAttribute('data-is-paused', 'true');
                    }
                    playPauseElement.innerHTML = playPauseText;
                });
            }
        }
    }
};
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var vimeoTag = document.createElement('script');
vimeoTag.src = "https://player.vimeo.com/api/player.js";
firstScriptTag.parentNode.insertBefore(vimeoTag, firstScriptTag);
window.onYouTubePlayerAPIReady = function () {
    var youtubeVideos = document.querySelectorAll('.youtube-js');
    var youtubeVideosArray = Array.prototype.slice.call(youtubeVideos);
    if (youtubeVideosArray) {
        youtubeVideosArray.forEach(function (video) {
            new YT.Player(video, {
                playerVars: {
                    'rel': 0,
                    'showinfo': 0,
                    'controls': 0,
                },
                events: {
                    'onReady': onReady,
                    'onStateChange': stateChange
                }
            });
        });
    }
};
window.addEventListener('load', function () {
    var vimeoVideos = Array.prototype.slice.call(document.querySelectorAll('.vimeo-js'));
    if (vimeoVideos) {
        vimeoVideos.forEach(function (video) {
            var player = new Vimeo.Player(video);
            var btnContainer = video.closest('.home-hero');
            var btn = null;
            if (btnContainer) {
                btn = btnContainer.querySelector('#pausePlayVideo');
            }
            else {
                btn = video.closest('.multimedia-video').querySelector('#pausePlayVideo');
            }
            if (btn) {
                player.on('play', function () {
                    setPausePlayIcons('play', btn);
                });
                player.on('pause', function () {
                    setPausePlayIcons('pause', btn);
                });
            }
        });
    }
});
function stateChange(event) {
    var videoObject = event.target;
    var videoIframe = videoObject.getIframe();
    var playerState = videoObject.getPlayerState();
    var pausePlayBtn = videoIframe.closest('.home-hero') != null ? videoIframe.closest('.home-hero').querySelector('#pausePlayVideo') : videoIframe.closest('.js_slide') != null ? videoIframe.closest('.js_slide').querySelector('#pausePlayVideo') : null;
    // if video playing
    if (playerState == 1) {
        setPausePlayIcons('play', pausePlayBtn);
    }
    else if (playerState == 2 || playerState == 0) {
        setPausePlayIcons('pause', pausePlayBtn);
    }
}
function onReady(event) {
    var videoObject = event.target;
    var videoIframe = videoObject.getIframe();
    var pausePlayBtn = videoIframe.closest('.home-hero') != null ? videoIframe.closest('.home-hero').querySelector('#pausePlayVideo') : null;
    if (pausePlayBtn != null) {
        pausePlayBtn.addEventListener('click', function () {
            playPause(pausePlayBtn, videoObject);
        });
    }
    var playBtn = videoIframe.closest('.multimedia-item') != null ? videoIframe.closest('.multimedia-item').querySelector('.home-hero-play') : null;
    if (playBtn != null) {
        playBtn.addEventListener('click', function () {
            playPause(playBtn, videoObject);
        });
    }
    var thumbnails = videoIframe.closest('.multimedia-item') != null ? videoIframe.closest('.multimedia-item').querySelectorAll('.multimedia-video-thumbnail') : null;
    if (thumbnails != null) {
        thumbnails.forEach(function (thumbnail) {
            thumbnail.addEventListener('click', function () {
                playPause(thumbnail, videoObject);
            });
        });
    }
    var muteUnmuteBtn = videoIframe.closest('.home-hero') != null ? videoIframe.closest('.home-hero').querySelector('#muteUnmuteVideo') : null;
    if (muteUnmuteBtn != null) {
        muteUnmuteBtn.addEventListener('click', function () {
            muteUnmute(muteUnmuteBtn, videoObject);
        });
    }
}
function setPausePlayIcons(state, button) {
    if (state == 'pause') {
        var carouselPauseBtn = document.querySelector('#carouselPlayPauseJS');
        if (carouselPauseBtn) {
            var carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');
            if (carouselPauseState == 'true') {
                carouselPauseBtn.click();
            }
        }
        var videoContainer = button.closest('.home-hero');
        if (videoContainer) {
            var thumbnailOverride = videoContainer.querySelector('.home-hero-bg-override');
            if (thumbnailOverride) {
                thumbnailOverride.classList.remove('home-hero-bg-override-hidden');
            }
            var thumbnailOverrideMobile = videoContainer.querySelector('.home-hero-bg-override-mobile');
            if (thumbnailOverrideMobile) {
                thumbnailOverrideMobile.classList.remove('home-hero-bg-override-mobile-hidden');
            }
        }
        button.classList.remove('home-hero-pause');
        button.classList.add('home-hero-play');
    }
    else if (state == 'play') {
        var carouselPauseBtn = document.querySelector('#carouselPlayPauseJS');
        if (carouselPauseBtn) {
            var carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');
            if (carouselPauseState == 'false') {
                carouselPauseBtn.click();
            }
        }
        var videoContainer = button.closest('.home-hero');
        if (videoContainer) {
            var thumbnailOverride = videoContainer.querySelector('.home-hero-bg-override');
            if (thumbnailOverride) {
                thumbnailOverride.classList.add('home-hero-bg-override-hidden');
            }
            var thumbnailOverrideMobile = videoContainer.querySelector('.home-hero-bg-override-mobile');
            if (thumbnailOverrideMobile) {
                thumbnailOverrideMobile.classList.add('home-hero-bg-override-mobile-hidden');
            }
            var muteUnmuteBtn = videoContainer.querySelector('#muteUnmuteVideo');
            if (muteUnmuteBtn.hasAttribute('disabled')) {
                muteUnmuteBtn.removeAttribute('disabled');
                muteUnmuteBtn.classList.add('clicked-js');
            }
        }
        button.classList.remove('home-hero-play');
        button.classList.add('home-hero-pause');
    }
}
function setMuteUnmuteIcons(state, button) {
    var carouselPauseBtn = document.querySelector('#carouselPlayPauseJS');
    if (state == 'mute') {
        if (carouselPauseBtn) {
            var carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');
            if (carouselPauseState == 'true') {
                carouselPauseBtn.click();
            }
        }
        button.classList.remove('home-hero-mute');
        button.classList.add('home-hero-unmute');
    }
    else if (state == 'unmute') {
        if (carouselPauseBtn) {
            var carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');
            if (carouselPauseState == 'false') {
                carouselPauseBtn.click();
            }
        }
        button.classList.remove('home-hero-unmute');
        button.classList.add('home-hero-mute');
    }
}
function playPause(pausePlayBtn, video) {
    var videoContainer = pausePlayBtn.closest('.home-hero');
    var playerState = video.getPlayerState();
    if (playerState == 1) {
        video.pauseVideo();
        setPausePlayIcons('pause', pausePlayBtn);
    }
    else {
        video.playVideo();
        setPausePlayIcons('play', pausePlayBtn);
    }
}
function muteUnmute(muteUnmuteBtn, video) {
    if (video.isMuted()) {
        video.unMute();
        setMuteUnmuteIcons('unmute', muteUnmuteBtn);
    }
    else {
        video.mute();
        setMuteUnmuteIcons('mute', muteUnmuteBtn);
    }
}
window.addEventListener('load', function () {
    var videos = document.querySelectorAll('.home-hero iframe, .home-hero video');
    if (videos) {
        setDimensions();
        window.addEventListener('resize', function () {
            setDimensions();
        });
    }
    function setDimensions() {
        var videosArray = Array.prototype.slice.call(videos);
        videosArray.forEach(function (video) {
            var videoContainer = video.closest('.carousel-container');
            var headerWidth = videoContainer.offsetWidth;
            var headerHeight = videoContainer.offsetHeight;
            video.style.width = Math.max(headerWidth, (headerHeight * 16 / 9)) + "px";
            video.style.height = Math.max((headerHeight + 480), (headerWidth * 9 / 16)) + "px";
            var videoThumbnail = videoContainer.querySelector('.home-hero-bg-image');
            videoThumbnail.style.height = Math.max((headerHeight + 480), (headerWidth * 9 / 16)) + "px";
        });
    }
    var pausePlayButtons = document.querySelectorAll('#pausePlayVideo[data-video-type="Vimeo"], #pausePlayVideo[data-video-type="Embedded"], .home-hero-play[data-video-type="Vimeo"], .home-hero-play[data-video-type="Embedded"], .multimedia-video-thumbnail[data-video-type="Vimeo"], .multimedia-video-thumbnail[data-video-type="Embedded"]');
    var muteUnmuteButtons = document.querySelectorAll('#muteUnmuteVideo[data-video-type="Vimeo"], #muteUnmuteVideo[data-video-type="Embedded"]');
    if (pausePlayButtons) {
        var pausePlayButtonsArray = Array.prototype.slice.call(pausePlayButtons);
        pausePlayButtonsArray.forEach(function (button) {
            button.addEventListener('click', function () {
                var videoId = button.getAttribute('data-associated-video');
                var video = document.getElementById(videoId);
                var videoType = button.getAttribute('data-video-type');
                if (videoType == "Vimeo") {
                    vimeoVideoPausePlay(button);
                }
                else {
                    embeddedVideoPausePlay(button);
                }
            });
        });
    }
    if (muteUnmuteButtons) {
        var muteUnmuteButtonsArray = Array.prototype.slice.call(muteUnmuteButtons);
        muteUnmuteButtonsArray.forEach(function (button) {
            button.addEventListener('click', function () {
                var videoId = button.getAttribute('data-associated-video');
                var video = document.getElementById(videoId);
                var videoType = button.getAttribute('data-video-type');
                if (videoType == "Vimeo") {
                    vimeoVideoMuteUnmute(button);
                }
                else {
                    embeddedVideoMuteUnmute(button);
                }
            });
        });
    }
    function vimeoVideoPausePlay(button) {
        var videoContainer = button.closest('.home-hero');
        if (videoContainer == null) {
            videoContainer = button.closest('.multimedia-item');
        }
        var video = videoContainer.querySelector('iframe');
        var player = new Vimeo.Player(video);
        player.getPaused().then(function (paused) {
            if (paused) {
                player.play();
            }
            else {
                player.pause();
            }
        });
    }
    function vimeoVideoMuteUnmute(button) {
        var videoContainer = button.closest('.home-hero');
        var video = videoContainer.querySelector('iframe');
        var player = new Vimeo.Player(video);
        player.getVolume().then(function (volume) {
            if (volume > 0) {
                player.setVolume(0);
                setMuteUnmuteIcons('mute', button);
            }
            else {
                player.setVolume(1);
                setMuteUnmuteIcons('unmute', button);
            }
        });
    }
    function embeddedVideoPausePlay(button) {
        var videoContainer = button.closest('.home-hero');
        if (videoContainer == null) {
            videoContainer = button.closest('.multimedia-item');
        }
        var video = videoContainer.querySelector('video');
        if (video != null && video.paused != null && video.paused == true) {
            video.play();
            setPausePlayIcons('play', button);
        }
        else {
            video.pause();
            setPausePlayIcons('pause', button);
        }
    }
    function embeddedVideoMuteUnmute(button) {
        var videoContainer = button.closest('.home-hero');
        var video = videoContainer.querySelector('video');
        if (video.muted == true) {
            video.muted = false;
            setMuteUnmuteIcons('unmute', button);
        }
        else {
            video.muted = true;
            setMuteUnmuteIcons('mute', button);
        }
    }
    function updateMobileAutoPlayControls() {
        var autoplayVideos = Array.prototype.slice.call(document.querySelectorAll('.auto-play-js'));
        if (autoplayVideos) {
            autoplayVideos.forEach(function (video) {
                var pauseBtn = video.closest('.home-hero').querySelector('.home-hero-pause');
                if (window.innerWidth <= 768) {
                    if (pauseBtn) {
                        pauseBtn.classList.remove('home-hero-pause');
                        pauseBtn.classList.add('home-hero-play');
                    }
                    if (video.classList.contains('native-video')) {
                        video.pause();
                    }
                }
            });
        }
    }
    function disableAudioControls() {
        var homeAreaCarousel = document.querySelector('#homeheroCarousel');
        if (homeAreaCarousel) {
            var audioControls = Array.prototype.slice.call(homeAreaCarousel.querySelectorAll('#muteUnmuteVideo'));
            if (audioControls) {
                audioControls.forEach(function (control) {
                    var isAutoPlay = control.closest('.home-hero').querySelector('.auto-play-js');
                    var autoPlayOnDesktop = isAutoPlay != null && window.innerWidth > 768;
                    if (!control.hasAttribute('disabled') && window.innerWidth < 769 && !control.classList.contains('clicked-js')) {
                        control.setAttribute('disabled', '');
                    }
                });
            }
        }
    }
    updateMobileAutoPlayControls();
    disableAudioControls();
    window.addEventListener('resize', function () {
        updateMobileAutoPlayControls();
        disableAudioControls();
    });
});


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* globals jQuery */
	
	exports.lory = lory;
	
	var _detectPrefixes = __webpack_require__(2);
	
	var _detectPrefixes2 = _interopRequireDefault(_detectPrefixes);
	
	var _dispatchEvent = __webpack_require__(3);
	
	var _dispatchEvent2 = _interopRequireDefault(_dispatchEvent);
	
	var _defaults = __webpack_require__(5);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slice = Array.prototype.slice;
	
	function lory(slider, opts) {
	    var position = void 0;
	    var slidesWidth = void 0;
	    var frameWidth = void 0;
	    var slides = void 0;
	
	    /**
	     * slider DOM elements
	     */
	    var frame = void 0;
	    var slideContainer = void 0;
	    var prevCtrl = void 0;
	    var nextCtrl = void 0;
	    var prefixes = void 0;
	    var transitionEndCallback = void 0;
	
	    var index = 0;
	    var options = {};
	
	    /**
	     * if object is jQuery convert to native DOM element
	     */
	    if (typeof jQuery !== 'undefined' && slider instanceof jQuery) {
	        slider = slider[0];
	    }
	
	    /**
	     * private
	     * set active class to element which is the current slide
	     */
	    function setActiveElement(slides, currentIndex) {
	        var _options = options,
	            classNameActiveSlide = _options.classNameActiveSlide;
	
	
	        slides.forEach(function (element, index) {
	            if (element.classList.contains(classNameActiveSlide)) {
	                element.classList.remove(classNameActiveSlide);
	            }
	        });
	
	        slides[currentIndex].classList.add(classNameActiveSlide);
	    }
	
	    /**
	     * private
	     * setupInfinite: function to setup if infinite is set
	     *
	     * @param  {array} slideArray
	     * @return {array} array of updated slideContainer elements
	     */
	    function setupInfinite(slideArray) {
	        var _options2 = options,
	            infinite = _options2.infinite;
	
	
	        var front = slideArray.slice(0, infinite);
	        var back = slideArray.slice(slideArray.length - infinite, slideArray.length);
	
	        front.forEach(function (element) {
	            var cloned = element.cloneNode(true);
	
	            slideContainer.appendChild(cloned);
	        });
	
	        back.reverse().forEach(function (element) {
	            var cloned = element.cloneNode(true);
	
	            slideContainer.insertBefore(cloned, slideContainer.firstChild);
	        });
	
	        slideContainer.addEventListener(prefixes.transitionEnd, onTransitionEnd);
	
	        return slice.call(slideContainer.children);
	    }
	
	    /**
	     * [dispatchSliderEvent description]
	     * @return {[type]} [description]
	     */
	    function dispatchSliderEvent(phase, type, detail) {
	        (0, _dispatchEvent2.default)(slider, phase + '.lory.' + type, detail);
	    }
	
	    /**
	     * translates to a given position in a given time in milliseconds
	     *
	     * @to        {number} number in pixels where to translate to
	     * @duration  {number} time in milliseconds for the transistion
	     * @ease      {string} easing css property
	     */
	    function translate(to, duration, ease) {
	        var style = slideContainer && slideContainer.style;
	
	        if (style) {
	            style[prefixes.transition + 'TimingFunction'] = ease;
	            style[prefixes.transition + 'Duration'] = duration + 'ms';
	
	            if (prefixes.hasTranslate3d) {
	                style[prefixes.transform] = 'translate3d(' + to + 'px, 0, 0)';
	            } else {
	                style[prefixes.transform] = 'translate(' + to + 'px, 0)';
	            }
	        }
	    }
	
	    /**
	     * slidefunction called by prev, next & touchend
	     *
	     * determine nextIndex and slide to next postion
	     * under restrictions of the defined options
	     *
	     * @direction  {boolean}
	     */
	    function slide(nextIndex, direction) {
	        var _options3 = options,
	            slideSpeed = _options3.slideSpeed,
	            slidesToScroll = _options3.slidesToScroll,
	            infinite = _options3.infinite,
	            rewind = _options3.rewind,
	            rewindSpeed = _options3.rewindSpeed,
	            ease = _options3.ease,
	            classNameActiveSlide = _options3.classNameActiveSlide;
	
	
	        var duration = slideSpeed;
	
	        var nextSlide = direction ? index + 1 : index - 1;
	        var maxOffset = Math.round(slidesWidth - frameWidth);
	
	        dispatchSliderEvent('before', 'slide', {
	            index: index,
	            nextSlide: nextSlide
	        });
	
	        /**
	         * Reset control classes
	         */
	        if (prevCtrl) {
	            prevCtrl.classList.remove('disabled');
	        }
	        if (nextCtrl) {
	            nextCtrl.classList.remove('disabled');
	        }
	
	        if (typeof nextIndex !== 'number') {
	            if (direction) {
	                nextIndex = index + slidesToScroll;
	            } else {
	                nextIndex = index - slidesToScroll;
	            }
	        }
	
	        nextIndex = Math.min(Math.max(nextIndex, 0), slides.length - 1);
	
	        if (infinite && direction === undefined) {
	            nextIndex += infinite;
	        }
	
	        var nextOffset = Math.min(Math.max(slides[nextIndex].offsetLeft * -1, maxOffset * -1), 0);
	
	        if (rewind && Math.abs(position.x) === maxOffset && direction) {
	            nextOffset = 0;
	            nextIndex = 0;
	            duration = rewindSpeed;
	        }
	
	        /**
	         * translate to the nextOffset by a defined duration and ease function
	         */
	        translate(nextOffset, duration, ease);
	
	        /**
	         * update the position with the next position
	         */
	        position.x = nextOffset;
	
	        /**
	         * update the index with the nextIndex only if
	         * the offset of the nextIndex is in the range of the maxOffset
	         */
	        if (slides[nextIndex].offsetLeft <= maxOffset) {
	            index = nextIndex;
	        }
	
	        if (infinite && (nextIndex === slides.length - infinite || nextIndex === 0)) {
	            if (direction) {
	                index = infinite;
	            }
	
	            if (!direction) {
	                index = slides.length - infinite * 2;
	            }
	
	            position.x = slides[index].offsetLeft * -1;
	
	            transitionEndCallback = function transitionEndCallback() {
	                translate(slides[index].offsetLeft * -1, 0, undefined);
	            };
	        }
	
	        if (classNameActiveSlide) {
	            setActiveElement(slice.call(slides), index);
	        }
	
	        /**
	         * update classes for next and prev arrows
	         * based on user settings
	         */
	        if (prevCtrl && !infinite && nextIndex === 0) {
	            prevCtrl.classList.add('disabled');
	        }
	
	        if (nextCtrl && !infinite && !rewind && nextIndex + 1 === slides.length) {
	            nextCtrl.classList.add('disabled');
	        }
	
	        dispatchSliderEvent('after', 'slide', {
	            currentSlide: index
	        });
	    }
	
	    /**
	     * public
	     * setup function
	     */
	    function setup() {
	        dispatchSliderEvent('before', 'init');
	
	        prefixes = (0, _detectPrefixes2.default)();
	        options = _extends({}, _defaults2.default, opts);
	
	        var _options4 = options,
	            classNameFrame = _options4.classNameFrame,
	            classNameSlideContainer = _options4.classNameSlideContainer,
	            classNamePrevCtrl = _options4.classNamePrevCtrl,
	            classNameNextCtrl = _options4.classNameNextCtrl,
	            enableMouseEvents = _options4.enableMouseEvents,
	            classNameActiveSlide = _options4.classNameActiveSlide;
	
	
	        frame = slider.getElementsByClassName(classNameFrame)[0];
	        slideContainer = frame.getElementsByClassName(classNameSlideContainer)[0];
	        prevCtrl = slider.getElementsByClassName(classNamePrevCtrl)[0];
	        nextCtrl = slider.getElementsByClassName(classNameNextCtrl)[0];
	
	        position = {
	            x: slideContainer.offsetLeft,
	            y: slideContainer.offsetTop
	        };
	
	        if (options.infinite) {
	            slides = setupInfinite(slice.call(slideContainer.children));
	        } else {
	            slides = slice.call(slideContainer.children);
	
	            if (prevCtrl) {
	                prevCtrl.classList.add('disabled');
	            }
	
	            if (nextCtrl && slides.length === 1 && !options.rewind) {
	                nextCtrl.classList.add('disabled');
	            }
	        }
	
	        reset();
	
	        if (classNameActiveSlide) {
	            setActiveElement(slides, index);
	        }
	
	        if (prevCtrl && nextCtrl) {
	            prevCtrl.addEventListener('click', prev);
	            nextCtrl.addEventListener('click', next);
	        }
	
	        frame.addEventListener('touchstart', onTouchstart);
	
	        if (enableMouseEvents) {
	            frame.addEventListener('mousedown', onTouchstart);
	            frame.addEventListener('click', onClick);
	        }
	
	        options.window.addEventListener('resize', onResize);
	
	        dispatchSliderEvent('after', 'init');
	    }
	
	    /**
	     * public
	     * reset function: called on resize
	     */
	    function reset() {
	        var _options5 = options,
	            infinite = _options5.infinite,
	            ease = _options5.ease,
	            rewindSpeed = _options5.rewindSpeed,
	            rewindOnResize = _options5.rewindOnResize,
	            classNameActiveSlide = _options5.classNameActiveSlide;
	
	
	        slidesWidth = slideContainer.getBoundingClientRect().width || slideContainer.offsetWidth;
	        frameWidth = frame.getBoundingClientRect().width || frame.offsetWidth;
	
	        if (frameWidth === slidesWidth) {
	            slidesWidth = slides.reduce(function (previousValue, slide) {
	                return previousValue + slide.getBoundingClientRect().width || slide.offsetWidth;
	            }, 0);
	        }
	
	        if (rewindOnResize) {
	            index = 0;
	        } else {
	            ease = null;
	            rewindSpeed = 0;
	        }
	
	        if (infinite) {
	            translate(slides[index + infinite].offsetLeft * -1, 0, null);
	
	            index = index + infinite;
	            position.x = slides[index].offsetLeft * -1;
	        } else {
	            translate(slides[index].offsetLeft * -1, rewindSpeed, ease);
	            position.x = slides[index].offsetLeft * -1;
	        }
	
	        if (classNameActiveSlide) {
	            setActiveElement(slice.call(slides), index);
	        }
	    }
	
	    /**
	     * public
	     * slideTo: called on clickhandler
	     */
	    function slideTo(index) {
	        slide(index);
	    }
	
	    /**
	     * public
	     * returnIndex function: called on clickhandler
	     */
	    function returnIndex() {
	        return index - options.infinite || 0;
	    }
	
	    /**
	     * public
	     * prev function: called on clickhandler
	     */
	    function prev() {
	        slide(false, false);
	    }
	
	    /**
	     * public
	     * next function: called on clickhandler
	     */
	    function next() {
	        slide(false, true);
	    }
	
	    /**
	     * public
	     * destroy function: called to gracefully destroy the lory instance
	     */
	    function destroy() {
	        dispatchSliderEvent('before', 'destroy');
	
	        // remove event listeners
	        frame.removeEventListener(prefixes.transitionEnd, onTransitionEnd);
	        frame.removeEventListener('touchstart', onTouchstart);
	        frame.removeEventListener('touchmove', onTouchmove);
	        frame.removeEventListener('touchend', onTouchend);
	        frame.removeEventListener('mousemove', onTouchmove);
	        frame.removeEventListener('mousedown', onTouchstart);
	        frame.removeEventListener('mouseup', onTouchend);
	        frame.removeEventListener('mouseleave', onTouchend);
	        frame.removeEventListener('click', onClick);
	
	        options.window.removeEventListener('resize', onResize);
	
	        if (prevCtrl) {
	            prevCtrl.removeEventListener('click', prev);
	        }
	
	        if (nextCtrl) {
	            nextCtrl.removeEventListener('click', next);
	        }
	
	        // remove cloned slides if infinite is set
	        if (options.infinite) {
	            Array.apply(null, Array(options.infinite)).forEach(function () {
	                slideContainer.removeChild(slideContainer.firstChild);
	                slideContainer.removeChild(slideContainer.lastChild);
	            });
	        }
	
	        dispatchSliderEvent('after', 'destroy');
	    }
	
	    // event handling
	
	    var touchOffset = void 0;
	    var delta = void 0;
	    var isScrolling = void 0;
	
	    function onTransitionEnd() {
	        if (transitionEndCallback) {
	            transitionEndCallback();
	
	            transitionEndCallback = undefined;
	        }
	    }
	
	    function onTouchstart(event) {
	        var _options6 = options,
	            enableMouseEvents = _options6.enableMouseEvents;
	
	        var touches = event.touches ? event.touches[0] : event;
	
	        if (enableMouseEvents) {
	            frame.addEventListener('mousemove', onTouchmove);
	            frame.addEventListener('mouseup', onTouchend);
	            frame.addEventListener('mouseleave', onTouchend);
	        }
	
	        frame.addEventListener('touchmove', onTouchmove);
	        frame.addEventListener('touchend', onTouchend);
	
	        var pageX = touches.pageX,
	            pageY = touches.pageY;
	
	
	        touchOffset = {
	            x: pageX,
	            y: pageY,
	            time: Date.now()
	        };
	
	        isScrolling = undefined;
	
	        delta = {};
	
	        dispatchSliderEvent('on', 'touchstart', {
	            event: event
	        });
	    }
	
	    function onTouchmove(event) {
	        var touches = event.touches ? event.touches[0] : event;
	        var pageX = touches.pageX,
	            pageY = touches.pageY;
	
	
	        delta = {
	            x: pageX - touchOffset.x,
	            y: pageY - touchOffset.y
	        };
	
	        if (typeof isScrolling === 'undefined') {
	            isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
	        }
	
	        if (!isScrolling && touchOffset) {
	            event.preventDefault();
	            translate(position.x + delta.x, 0, null);
	        }
	
	        // may be
	        dispatchSliderEvent('on', 'touchmove', {
	            event: event
	        });
	    }
	
	    function onTouchend(event) {
	        /**
	         * time between touchstart and touchend in milliseconds
	         * @duration {number}
	         */
	        var duration = touchOffset ? Date.now() - touchOffset.time : undefined;
	
	        /**
	         * is valid if:
	         *
	         * -> swipe attempt time is over 300 ms
	         * and
	         * -> swipe distance is greater than 25px
	         * or
	         * -> swipe distance is more then a third of the swipe area
	         *
	         * @isValidSlide {Boolean}
	         */
	        var isValid = Number(duration) < 300 && Math.abs(delta.x) > 25 || Math.abs(delta.x) > frameWidth / 3;
	
	        /**
	         * is out of bounds if:
	         *
	         * -> index is 0 and delta x is greater than 0
	         * or
	         * -> index is the last slide and delta is smaller than 0
	         *
	         * @isOutOfBounds {Boolean}
	         */
	        var isOutOfBounds = !index && delta.x > 0 || index === slides.length - 1 && delta.x < 0;
	
	        var direction = delta.x < 0;
	
	        if (!isScrolling) {
	            if (isValid && !isOutOfBounds) {
	                slide(false, direction);
	            } else {
	                translate(position.x, options.snapBackSpeed);
	            }
	        }
	
	        touchOffset = undefined;
	
	        /**
	         * remove eventlisteners after swipe attempt
	         */
	        frame.removeEventListener('touchmove', onTouchmove);
	        frame.removeEventListener('touchend', onTouchend);
	        frame.removeEventListener('mousemove', onTouchmove);
	        frame.removeEventListener('mouseup', onTouchend);
	        frame.removeEventListener('mouseleave', onTouchend);
	
	        dispatchSliderEvent('on', 'touchend', {
	            event: event
	        });
	    }
	
	    function onClick(event) {
	        if (delta.x) {
	            event.preventDefault();
	        }
	    }
	
	    function onResize(event) {
	        reset();
	
	        dispatchSliderEvent('on', 'resize', {
	            event: event
	        });
	    }
	
	    // trigger initial setup
	    setup();
	
	    // expose public api
	    return {
	        setup: setup,
	        reset: reset,
	        slideTo: slideTo,
	        returnIndex: returnIndex,
	        prev: prev,
	        next: next,
	        destroy: destroy
	    };
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = detectPrefixes;
	/**
	 * Detecting prefixes for saving time and bytes
	 */
	function detectPrefixes() {
	    var transform = void 0;
	    var transition = void 0;
	    var transitionEnd = void 0;
	    var hasTranslate3d = void 0;
	
	    (function () {
	        var el = document.createElement('_');
	        var style = el.style;
	
	        var prop = void 0;
	
	        if (style[prop = 'webkitTransition'] === '') {
	            transitionEnd = 'webkitTransitionEnd';
	            transition = prop;
	        }
	
	        if (style[prop = 'transition'] === '') {
	            transitionEnd = 'transitionend';
	            transition = prop;
	        }
	
	        if (style[prop = 'webkitTransform'] === '') {
	            transform = prop;
	        }
	
	        if (style[prop = 'msTransform'] === '') {
	            transform = prop;
	        }
	
	        if (style[prop = 'transform'] === '') {
	            transform = prop;
	        }
	
	        document.body.insertBefore(el, null);
	        style[transform] = 'translate3d(0, 0, 0)';
	        hasTranslate3d = !!global.getComputedStyle(el).getPropertyValue(transform);
	        document.body.removeChild(el);
	    })();
	
	    return {
	        transform: transform,
	        transition: transition,
	        transitionEnd: transitionEnd,
	        hasTranslate3d: hasTranslate3d
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = dispatchEvent;
	
	var _customEvent = __webpack_require__(4);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * dispatch custom events
	 *
	 * @param  {element} el         slideshow element
	 * @param  {string}  type       custom event name
	 * @param  {object}  detail     custom detail information
	 */
	function dispatchEvent(target, type, detail) {
	    var event = new _customEvent2.default(type, {
	        bubbles: true,
	        cancelable: true,
	        detail: detail
	    });
	
	    target.dispatchEvent(event);
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var NativeCustomEvent = global.CustomEvent;
	
	function useNative () {
	  try {
	    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
	    return  'cat' === p.type && 'bar' === p.detail.foo;
	  } catch (e) {
	  }
	  return false;
	}
	
	/**
	 * Cross-browser `CustomEvent` constructor.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
	 *
	 * @public
	 */
	
	module.exports = useNative() ? NativeCustomEvent :
	
	// IE >= 9
	'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
	  var e = document.createEvent('CustomEvent');
	  if (params) {
	    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
	  } else {
	    e.initCustomEvent(type, false, false, void 0);
	  }
	  return e;
	} :
	
	// IE <= 8
	function CustomEvent (type, params) {
	  var e = document.createEventObject();
	  e.type = type;
	  if (params) {
	    e.bubbles = Boolean(params.bubbles);
	    e.cancelable = Boolean(params.cancelable);
	    e.detail = params.detail;
	  } else {
	    e.bubbles = false;
	    e.cancelable = false;
	    e.detail = void 0;
	  }
	  return e;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  /**
	   * slides scrolled at once
	   * @slidesToScroll {Number}
	   */
	  slidesToScroll: 1,
	
	  /**
	   * time in milliseconds for the animation of a valid slide attempt
	   * @slideSpeed {Number}
	   */
	  slideSpeed: 300,
	
	  /**
	   * time in milliseconds for the animation of the rewind after the last slide
	   * @rewindSpeed {Number}
	   */
	  rewindSpeed: 600,
	
	  /**
	   * time for the snapBack of the slider if the slide attempt was not valid
	   * @snapBackSpeed {Number}
	   */
	  snapBackSpeed: 200,
	
	  /**
	   * Basic easing functions: https://developer.mozilla.org/de/docs/Web/CSS/transition-timing-function
	   * cubic bezier easing functions: http://easings.net/de
	   * @ease {String}
	   */
	  ease: 'ease',
	
	  /**
	   * if slider reached the last slide, with next click the slider goes back to the startindex.
	   * use infinite or rewind, not both
	   * @rewind {Boolean}
	   */
	  rewind: false,
	
	  /**
	   * number of visible slides or false
	   * use infinite or rewind, not both
	   * @infinite {number}
	   */
	  infinite: false,
	
	  /**
	   * class name for slider frame
	   * @classNameFrame {string}
	   */
	  classNameFrame: 'js_frame',
	
	  /**
	   * class name for slides container
	   * @classNameSlideContainer {string}
	   */
	  classNameSlideContainer: 'js_slides',
	
	  /**
	   * class name for slider prev control
	   * @classNamePrevCtrl {string}
	   */
	  classNamePrevCtrl: 'js_prev',
	
	  /**
	   * class name for slider next control
	   * @classNameNextCtrl {string}
	   */
	  classNameNextCtrl: 'js_next',
	
	  /**
	   * class name for current active slide
	   * if emptyString then no class is set
	   * @classNameActiveSlide {string}
	   */
	  classNameActiveSlide: 'active',
	
	  /**
	   * enables mouse events for swiping on desktop devices
	   * @enableMouseEvents {boolean}
	   */
	  enableMouseEvents: false,
	
	  /**
	   * window instance
	   * @window {object}
	   */
	  window: window,
	
	  /**
	   * If false, slides lory to the first slide on window resize.
	   * @rewindOnResize {boolean}
	   */
	  rewindOnResize: true
	};

/***/ }
/******/ ])
});
;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// carousel-bundle.js